import React from 'react'
import { Flex } from "reflexbox"

const Row = props => <Flex {...props} mx={-3} flexWrap="wrap" />

export default Row
